// extracted by mini-css-extract-plugin
export var showcaseImage = "showcase-image-module--showcase-image--2yfk8";
export var image = "showcase-image-module--image--KPT7x";